import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { QueryKey, useInfiniteQuery } from 'react-query'

import type { AudioAsset } from 'types'

interface StockAudioResponse {
  items: AudioAsset[]
  total: number
}

interface Props {
  query: string
  queryKey?: QueryKey
  perPage?: number
  minDuration?: number
}

interface Options {
  enabled?: boolean
}

export const useStockAudio = (
  { perPage = 20, query, minDuration, queryKey = ['stockAudio', query] }: Props,
  options: Options = {},
) => {
  const MINUTE = 1000 * 60

  return useInfiniteQuery<StockAudioResponse>(
    queryKey,
    async ({ pageParam = 1 }) => {
      const url = `/storyblocks/audio?query=${encodeURIComponent(
        query,
      )}&page=${pageParam}&per_page=${perPage}&min_duration=${minDuration}`

      const response = await sendToApi<StockAudioResponse>(url)
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Failed to load audio')
      }
      return response.data
    },
    {
      ...options,
      cacheTime: MINUTE * 3,
      staleTime: MINUTE * 3,
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage) return undefined
        const currentPage = allPages.length
        const totalPages = Math.ceil(lastPage.total / perPage)

        if (currentPage < totalPages) return currentPage + 1

        return undefined
      },
    },
  )
}
